import WidgetInProgress from './WidgetInProgress';

export default WidgetInProgress;
